import React from "react";
import './Main.css'
import SectionAlert from "./SectionAlert/SectionAlert.js";
import About from "./About/About";
import SectionImage from "./SectionImage/SectionImage";
import titleImageOne from "../../assets/images/photo3.jpg"
import titleImageTwo from "../../assets/images/cennik.jpg"
import titleImageThree from "../../assets/images/photo1.jpg"
import Attractions from "./Attractions/Attractions";
import Price from "./Price/Price.js"
import Security from "./Security/Security";

const Main = ()=>{
    return(
        <main>
            <h2 className="section-title">Park Linowy</h2>
            <SectionAlert/>
            <About/>
            <SectionImage
            photo={titleImageOne}
            title="Trasy"
            description="Trzy różnorodne trasy"
            topBlock="tl"
            bottomBlock="br"
            />
            <Attractions/>
            <SectionImage
            photo={titleImageTwo}
            title="Cennik"
            description="Daj się ponieść dobrej zabawie"
            topBlock="tr"
            bottomBlock="bl"
            />
            <Price/>
            <SectionImage
            photo={titleImageThree}
            title="Bezpieczeństwo"
            description="Dbaj o bezpieczeństwo swoje oraz innych"
            topBlock="tl"
            bottomBlock="br"
            />
            <Security/>
        </main>
    )
}

export default Main;